import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=25344db3&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25344db3')) {
      api.createRecord('25344db3', component.options)
    } else {
      api.reload('25344db3', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=25344db3&", function () {
      api.rerender('25344db3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2M8rXvHs5V9e8/JS/imageCarousel.vue"
export default component.exports